// extracted by mini-css-extract-plugin
export default {"root":"jCXdMD1Lo8Yu4qX66TmM","innerContainer":"GQ5VUZ7fCLdBpOzhK3t2"};